export default "__VITE_ASSET__TeRqzycv__"